import { Component, Host, State, h } from '@stencil/core';

@Component({
  tag: 'lgr-phone-number',
  styleUrl: 'phoneNumber.scss',
  shadow: true,
})
export class PhoneNumber {
  @State() visible: boolean = false;

  render() {
    return (
      <Host
        tabindex="0"
        onClick={() => {
          this.visible = true;
        }}
      >
        <div class='lgr-phone-number-icon'>
          <lgr-icon>call</lgr-icon>
        </div>
        <div class='lgr-phone-number-text'>
          <slot></slot>
        </div>
        <span
          class={{
            'lgr-phone-number-mask': true,
            'lgr-phone-number-mask-visible': this.visible
          }}
        />
      </Host>
    );
  }

}
